export default {
  "fullscreen-base": "_fullscreen-base_1leptt",
  "close-wrapper": "_close-wrapper_1leptt",
  "close-wrapper--base": "_close-wrapper--base_1leptt",
  "close-button": "_close-button_1leptt",
  "close-button--base": "_close-button--base_1leptt"
};